import type React from 'react';

import { Waypoint } from 'src/app/shared/components/scroll';

import { AutoTaggedPetition } from './components/AutoTaggedPetition';
import { Carousel } from './components/carousel';
import { DecisionMakerRecommendation } from './components/DecisionMakerRecommendation';
import { EmailDecisionMaker } from './components/EmailDecisionMaker';
import { FreePromotionFulfillment } from './components/FreePromotionFulfillment';
import { NOTIFICATION_TYPES } from './constants';
import { useNotificationsCenter } from './hooks/useNotificationsCenter';

export const NotificationsCenter: React.FC = () => {
	const { data, actions } = useNotificationsCenter();

	return (
		<Carousel className="p-6">
			{data.notifications.map((notification) => {
				switch (notification.type) {
					case NOTIFICATION_TYPES.freePromotionFulfillment:
						return (
							<div className="flex h-full w-full" key="free-promotion-fulfillment">
								<FreePromotionFulfillment onDismiss={() => actions.dismissNotification(notification.type)} />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);
					case NOTIFICATION_TYPES.decisionMakerRecommendation:
						return (
							<div className="flex h-full w-full" key="dm-recommendation">
								<DecisionMakerRecommendation onDismiss={() => actions.dismissNotification(notification.type)} />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);
					case NOTIFICATION_TYPES.autoTaggedPetition:
						return (
							<div className="flex h-full w-full" key="auto-tagged">
								<AutoTaggedPetition onDismiss={() => actions.dismissNotification(notification.type)} />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);

					case NOTIFICATION_TYPES.emailDecisionMaker:
						return (
							<div className="flex h-full w-full" key="starter-can-email-dm">
								<EmailDecisionMaker onDismiss={() => actions.dismissNotification(notification.type)} />
								<Waypoint horizontal onEnter={() => actions.trackNotificationView(notification.type)} />
							</div>
						);
					default:
						return null;
				}
			})}
		</Carousel>
	);
};
